// Reactive safety net for users who never see the FrontendUpdateBanner
// (e.g. tab was closed during a deploy) and then try to load a lazy chunk
// that no longer exists. On a dynamic-import error, reload the page once
// for the same route key — second hit on the same key stops the loop.

const CHUNK_RELOAD_KEY = 'prufa:chunk-reload'

const DYNAMIC_IMPORT_PATTERNS = [
  'failed to fetch dynamically imported module',
  'error loading dynamically imported module',
  'importing a module script failed',
  'chunkloaderror',
]

function getErrorMessage(error) {
  if (error instanceof Error) return error.message
  if (typeof error === 'string') return error
  return ''
}

export function isDynamicImportError(error) {
  const message = getErrorMessage(error).toLowerCase()
  if (!message) return false
  return DYNAMIC_IMPORT_PATTERNS.some((pattern) => message.includes(pattern))
}

function getRouteKey(win) {
  const { pathname, search, hash } = win.location
  return `${pathname}${search}${hash}`
}

function recoverFromChunkLoadError(win) {
  const routeKey = getRouteKey(win)
  const previous = (() => {
    try { return win.sessionStorage.getItem(CHUNK_RELOAD_KEY) } catch { return null }
  })()

  if (previous === routeKey) {
    try { win.sessionStorage.removeItem(CHUNK_RELOAD_KEY) } catch { /* ignore */ }
    return false
  }

  try { win.sessionStorage.setItem(CHUNK_RELOAD_KEY, routeKey) } catch { /* ignore */ }
  win.location.assign(routeKey)
  return true
}

export function installChunkLoadRecovery(router) {
  if (typeof window === 'undefined') return

  router.onError((error) => {
    if (!isDynamicImportError(error)) return
    recoverFromChunkLoadError(window)
  })

  router.afterEach(() => {
    try { window.sessionStorage.removeItem(CHUNK_RELOAD_KEY) } catch { /* ignore */ }
  })

  window.addEventListener('vite:preloadError', (event) => {
    event.preventDefault?.()
    recoverFromChunkLoadError(window)
  })
}
